import React, { useState, useEffect } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch, useSelector } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { UpdateCompanyAPI, UpdateSupplierByIdApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import { fetchSuppliers } from "../../store/Slices/SupplierSlice";

const EditSupplierModal = ({ open, setOpen, supplierData }) => {
  console.log(supplierData);
  const [Name, setName] = useState("");
  const [Address, setAddress] = useState("");
  const [Contact, setContact] = useState("");
  const [Desc, setDesc] = useState("");
  const [Loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (supplierData) {
      setName(supplierData.name || "");
      setAddress(supplierData.address || "");
      setContact(supplierData.contact || "");
      setDesc(supplierData.description || "");
    }
  }, [supplierData]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (Name === "") {
      WarningToast("Enter a valid name");
    } else if (Address === "") {
      WarningToast("Enter a valid address");
    } else if (Contact === "") {
      WarningToast("Enter a valid contact number");
    } else {
      try {
        const payload = {
          name: Name,
          contact: Contact,
          description: Desc,
          address: Address,
        };
        console.log(payload);
        const response = await UpdateCompanyAPI(supplierData._id, payload);

        if (response.data.success) {
          setOpen(false);
          SuccessToast("Supplier updated successfully");
          dispatch(fetchSuppliers());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.log(err);
        ErrorToast("Failed to update supplier");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Edit Companies
        </h1>
        <div className="flex flex-col px-10 gap-y-4">
          <AuthInput
            label="Name"
            placeholder="Enter Name"
            Value={Name}
            setValue={setName}
          />
          <AuthInput
            label="Address"
            placeholder="Enter Address"
            Value={Address}
            setValue={setAddress}
          />
          <AuthInput
            label="Contact"
            placeholder="Enter Contact"
            Value={Contact}
            setValue={setContact}
          />
          <AuthInput
            label="Desc"
            placeholder="Enter Description"
            Value={Desc}
            setValue={setDesc}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {Loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title="Update Supplier" onSubmit={onSubmit} type={1} />
              <AuthBtn
                title="Cancel"
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditSupplierModal;
